<template>
	<div>
		<div class="stage">
			<div class="row margin-b20">
				<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
					<div class="backBtn mobileMargin-b15">
						<router-link to="/mobilesims"
							><p
								class="textUppercase textGrey textXsml fontHeavy hover:text-[#555555] dark:hover:text-[#eeeeee]"
							>
								<span class="fa-light fa-arrow-left textGrey"></span> Take me back
							</p></router-link
						>
					</div>
				</div>
				<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
					<ul class="stepBtnsRight">
						<li>
							<button
								:disabled="saving || editSim.id ? !hasSubscriberChanges : !isValid"
								class="jmiBtn btnLg green"
								@click="save()"
							>
								{{ saving ? 'Activating...' : editSim.id ? 'Save' : 'Activate' }}
							</button>
						</li>
						<li><button class="jmiBtn btnLg red" @click="routeTo('/mobilesims')">Close</button></li>
					</ul>
				</div>
			</div>
			<div class="row margin-b10">
				<div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-lg-offset-3">
					<div class="card detailCard flex flex-col rounded-sm shadow-lg">
						<div class="mx-auto mb-5 w-full">
							<div class="col-sm-12 textCenter">
								<div class="navAvatar margin-b10 flex w-full justify-center">
									<img src="/assets/images/teleflow-logo-black.png" width="200" />
								</div>
							</div>
						</div>
						<div v-if="!loading">
							<div class="flex w-full justify-center">
								<div v-if="editSim.id">
									<div class="mb-4 flex flex-col items-center">
										<div class="mb-2 flex items-center">
											<span class="fa-light fa-sim-card mr-2 text-primary"></span>
											<h1>
												<span v-if="editSim.number">{{ editSim.number }}</span> ({{
													editSim.type === 'psim' ? 'Physical SIM' : 'eSIM'
												}})
											</h1>
										</div>
										<p>Status: {{ editSim.details?.status || 'Unknown' }}</p>
										<p class="text-gray-600">ICCID: {{ editSim.iccid || 'Not Set' }}</p>
									</div>
								</div>
								<h1 v-else class="mb-4">Activate (e)SIM</h1>
							</div>
							<div class="mx-auto w-full">
								<div v-if="!editSim.id" class="mb-4 border-b border-dark dark:border-light">
									<h3 class="mb-3 text-lg font-semibold">General</h3>
								</div>
								<div v-if="!editSim.id" class="mb-4 flex w-full flex-wrap">
									<div class="w-full px-2">
										<div class="formGroup withIcon">
											<label class="textGrey">Select Tenant</label>
											<select v-model="editSim.tenant" @change="tenantChanged">
												<option disabled :value="null">-- Select Tenant --</option>
												<option v-for="tenant in tenants" :key="tenant.id" :value="tenant">
													{{ tenant.companyName }}
												</option>
											</select>
											<span class="fa-light fa-chevron-down"></span>
										</div>
									</div>
								</div>
								<div v-if="!editSim.id && editSim.tenant" class="mb-4 flex w-full flex-wrap">
									<div class="w-full px-2">
										<div class="formGroup withIcon">
											<label class="textGrey">Select Account</label>
											<select v-model="editSim.account">
												<option disabled :value="null">-- Select Account --</option>
												<option
													v-for="account in tenantAccounts"
													:key="account.id"
													:value="account"
												>
													{{ account.name }}
												</option>
											</select>
											<span class="fa-light fa-chevron-down"></span>
										</div>
									</div>
								</div>

								<div
									v-if="!editSim.id && editSim.tenant && editSim.account"
									class="mb-4 flex w-full flex-wrap"
								>
									<div class="w-full px-2">
										<div class="formGroup withIcon">
											<label class="textGrey">Product</label>
											<select v-model="editSim.product">
												<option disabled :value="null">-- Select Product --</option>
												<option
													v-for="product in tenantProducts"
													:key="product.id"
													:value="product.spec"
												>
													{{ product.name }}
												</option>
											</select>
											<span class="fa-light fa-chevron-down"></span>
										</div>
									</div>
								</div>
								<div v-if="!editSim.id" class="mb-4 border-b border-dark dark:border-light">
									<h3 class="mb-3 text-lg font-semibold">SIM Details</h3>
								</div>
								<div v-if="editSim.id" class="mb-4 flex w-full flex-wrap items-center justify-center">
									<div class="w-full px-2">
										<div class="formGroup">
											<div
												class="grid grid-cols-2 gap-2 sm:flex sm:flex-wrap sm:items-center sm:justify-center sm:gap-2"
											>
												<Dialog v-if="editSim.id && editSim.product">
													<DialogTrigger>
														<button class="jmiBtn blue w-full sm:w-auto" type="button">
															<span class="fa-light fa-list-check mr-2"></span>
															Show Services
														</button>
													</DialogTrigger>
													<DialogContent class="max-w-xl">
														<DialogHeader>
															<DialogTitle>SIM Product Info</DialogTitle>
															<DialogDescription>
																<p>Services associated with this SIM</p>
															</DialogDescription>
														</DialogHeader>
														<div class="text-left">
															<div>
																<div
																	v-for="key in Object.keys(editSim.product)"
																	:key="key"
																	class="mb-2 flex items-center justify-between"
																>
																	<span class="font-medium">{{ key }}</span>
																	<span>{{ editSim.product[key] }}</span>
																</div>
															</div>
														</div>
													</DialogContent>
												</Dialog>
												<button
													v-if="editSim.type === 'esim'"
													class="jmiBtn green w-full sm:w-auto"
													@click="showQRCode"
												>
													<span class="fa-light fa-qrcode mr-2"></span>
													QR Code
												</button>
												<button
													v-if="
														!isTerminated &&
														!isPending &&
														editSim.details?.status !== 'Suspended'
													"
													class="jmiBtn orange w-full sm:w-auto"
													@click="handleSuspend"
												>
													<span class="fa-light fa-pause mr-2"></span>
													Suspend
												</button>
												<button
													v-if="
														!isTerminated &&
														!isPending &&
														editSim.details?.status === 'Suspended'
													"
													class="jmiBtn green w-full sm:w-auto"
													@click="handleReactivate"
												>
													<span class="fa-light fa-play mr-2"></span>
													Reactivate
												</button>
												<button
													v-if="!isTerminated && !isPending"
													class="jmiBtn red w-full sm:w-auto"
													@click="handleTerminate"
												>
													<span class="fa-light fa-stop mr-2"></span>
													Terminate
												</button>
												<button
													v-if="!isPending"
													class="jmiBtn blue w-full sm:w-auto"
													@click="handleSync"
												>
													<span class="fa-light fa-sync mr-2"></span>
													Sync
												</button>
											</div>
										</div>
									</div>
								</div>
								<div v-if="!editSim.id" class="mb-4 flex w-full flex-wrap">
									<div class="w-full px-2">
										<div class="formGroup withIcon">
											<label class="textGrey">SIM Type</label>
											<select v-model="editSim.type" :disabled="!!editSim.id">
												<option disabled :value="null">-- Select SIM Type --</option>
												<option value="psim">Physical SIM</option>
												<option value="esim">eSIM</option>
											</select>
											<span class="fa-light fa-chevron-down"></span>
										</div>
									</div>
								</div>
								<div v-if="!editSim.id && editSim.type === 'psim'" class="mb-4 flex w-full flex-wrap">
									<div class="w-full px-2">
										<div class="formGroup withIcon">
											<label class="textGrey">ICCID</label>
											<FormKit
												v-model="editSim.iccid"
												type="text"
												class="form-control"
												placeholder="8901234567890123456"
												name="ICCID"
												:validation="[['required'], ['matches', /^89\d{17,19}$/]]"
												:validation-messages="{
													matches: 'ICCID must be 19-21 digits starting with 89'
												}"
												validation-visibility="live"
												:disabled="!!editSim.id"
											/>
										</div>
									</div>
								</div>

								<div class="mb-4 border-b border-dark dark:border-light">
									<h3 class="mb-3 text-lg font-semibold">Personal Information</h3>
								</div>
								<div class="mb-2 flex w-full flex-row flex-wrap md:mb-5">
									<div class="w-full px-2 md:w-1/2">
										<div class="w-full">
											<div class="formGroup withIcon">
												<label class="textGrey">Title</label>
												<select v-model="editSim.subscriber.title">
													<option disabled :value="null">-- Select Title --</option>
													<option value="Mr">Mr</option>
													<option value="Mrs">Mrs</option>
													<option value="Ms">Ms</option>
												</select>
												<span class="fa-light fa-chevron-down"></span>
											</div>
										</div>
									</div>
									<div class="w-full px-2 md:w-1/2">
										<div class="w-full">
											<div class="formGroup">
												<label class="textGrey">Company</label>
												<input
													v-model="editSim.subscriber.company"
													type="text"
													class="form-control"
												/>
											</div>
										</div>
									</div>
								</div>
								<div class="mb-2 flex w-full flex-row flex-wrap md:mb-5">
									<div class="w-full px-2 md:w-1/2">
										<div class="w-full">
											<div class="formGroup">
												<label class="textGrey">First Name</label>
												<input
													v-model="editSim.subscriber.first_name"
													type="text"
													class="form-control"
												/>
											</div>
										</div>
									</div>
									<div class="w-full px-2 md:w-1/2">
										<div class="w-full">
											<div class="formGroup">
												<label class="textGrey">Last Name</label>
												<input
													v-model="editSim.subscriber.last_name"
													type="text"
													class="form-control"
												/>
											</div>
										</div>
									</div>
								</div>
								<div class="mb-2 flex w-full flex-row flex-wrap md:mb-5">
									<div class="w-full px-2 md:w-1/2">
										<div class="w-full">
											<div class="formGroup">
												<label class="textGrey">Email</label>
												<input
													v-model="editSim.subscriber.email"
													type="email"
													class="form-control"
												/>
											</div>
										</div>
									</div>
									<div class="w-full px-2 md:w-1/2">
										<div class="w-full">
											<div class="formGroup">
												<label class="textGrey">Date of Birth</label>
												<FormKit
													v-model="editSim.subscriber.dob"
													type="date"
													class="form-control"
												/>
											</div>
										</div>
									</div>
								</div>

								<div class="mb-4 border-b border-dark dark:border-light">
									<h3 class="mb-3 text-lg font-semibold">Address Information</h3>
								</div>
								<div class="mb-2 flex w-full flex-row flex-wrap md:mb-5">
									<div class="w-full px-2">
										<div class="w-full">
											<div class="formGroup">
												<label class="textGrey">Address</label>
												<input
													v-model="editSim.subscriber.address"
													type="text"
													class="form-control"
												/>
											</div>
										</div>
									</div>
								</div>
								<div class="mb-2 flex w-full flex-row flex-wrap md:mb-5">
									<div class="w-full px-2 md:w-1/2">
										<div class="w-full">
											<div class="formGroup">
												<label class="textGrey">City</label>
												<input
													v-model="editSim.subscriber.city"
													type="text"
													class="form-control"
												/>
											</div>
										</div>
									</div>
									<div class="w-full px-2 md:w-1/2">
										<div class="w-full">
											<div class="formGroup">
												<label class="textGrey">Postcode</label>
												<input
													v-model="editSim.subscriber.postcode"
													type="text"
													class="form-control"
												/>
											</div>
										</div>
									</div>
								</div>
								<div class="mb-2 flex w-full flex-row flex-wrap md:mb-5">
									<div class="w-full px-2 md:w-1/2">
										<div class="w-full">
											<div class="formGroup withIcon">
												<label class="textGrey">Country</label>
												<select id="country-select" v-model="editSim.subscriber.country">
													<option value="AFG">Afghanistan</option>
													<option value="ALB">Albania</option>
													<option value="DZA">Algeria</option>
													<option value="AND">Andorra</option>
													<option value="AGO">Angola</option>
													<option value="ATG">Antigua and Barbuda</option>
													<option value="ARG">Argentina</option>
													<option value="ARM">Armenia</option>
													<option value="AUS">Australia</option>
													<option value="AUT">Austria</option>
													<option value="AZE">Azerbaijan</option>
													<option value="BHS">Bahamas</option>
													<option value="BHR">Bahrain</option>
													<option value="BGD">Bangladesh</option>
													<option value="BRB">Barbados</option>
													<option value="BLR">Belarus</option>
													<option value="BEL">Belgium</option>
													<option value="BLZ">Belize</option>
													<option value="BEN">Benin</option>
													<option value="BTN">Bhutan</option>
													<option value="BOL">Bolivia</option>
													<option value="BIH">Bosnia and Herzegovina</option>
													<option value="BWA">Botswana</option>
													<option value="BRA">Brazil</option>
													<option value="BRN">Brunei</option>
													<option value="BGR">Bulgaria</option>
													<option value="BFA">Burkina Faso</option>
													<option value="BDI">Burundi</option>
													<option value="CPV">Cabo Verde</option>
													<option value="KHM">Cambodia</option>
													<option value="CMR">Cameroon</option>
													<option value="CAN">Canada</option>
													<option value="CAF">Central African Republic</option>
													<option value="TCD">Chad</option>
													<option value="CHL">Chile</option>
													<option value="CHN">China</option>
													<option value="COL">Colombia</option>
													<option value="COM">Comoros</option>
													<option value="COG">Congo (Congo-Brazzaville)</option>
													<option value="CRI">Costa Rica</option>
													<option value="CIV">Côte d'Ivoire</option>
													<option value="HRV">Croatia</option>
													<option value="CUB">Cuba</option>
													<option value="CYP">Cyprus</option>
													<option value="CZE">Czechia</option>
													<option value="COD">Democratic Republic of the Congo</option>
													<option value="DNK">Denmark</option>
													<option value="DJI">Djibouti</option>
													<option value="DMA">Dominica</option>
													<option value="DOM">Dominican Republic</option>
													<option value="ECU">Ecuador</option>
													<option value="EGY">Egypt</option>
													<option value="SLV">El Salvador</option>
													<option value="GNQ">Equatorial Guinea</option>
													<option value="ERI">Eritrea</option>
													<option value="EST">Estonia</option>
													<option value="SWZ">Eswatini</option>
													<option value="ETH">Ethiopia</option>
													<option value="FJI">Fiji</option>
													<option value="FIN">Finland</option>
													<option value="FRA">France</option>
													<option value="GAB">Gabon</option>
													<option value="GMB">Gambia</option>
													<option value="GEO">Georgia</option>
													<option value="DEU">Germany</option>
													<option value="GHA">Ghana</option>
													<option value="GRC">Greece</option>
													<option value="GRD">Grenada</option>
													<option value="GTM">Guatemala</option>
													<option value="GIN">Guinea</option>
													<option value="GNB">Guinea-Bissau</option>
													<option value="GUY">Guyana</option>
													<option value="HTI">Haiti</option>
													<option value="HND">Honduras</option>
													<option value="HUN">Hungary</option>
													<option value="ISL">Iceland</option>
													<option value="IND">India</option>
													<option value="IDN">Indonesia</option>
													<option value="IRN">Iran</option>
													<option value="IRQ">Iraq</option>
													<option value="IRL">Ireland</option>
													<option value="ISR">Israel</option>
													<option value="ITA">Italy</option>
													<option value="JAM">Jamaica</option>
													<option value="JPN">Japan</option>
													<option value="JOR">Jordan</option>
													<option value="KAZ">Kazakhstan</option>
													<option value="KEN">Kenya</option>
													<option value="KIR">Kiribati</option>
													<option value="KWT">Kuwait</option>
													<option value="KGZ">Kyrgyzstan</option>
													<option value="LAO">Laos</option>
													<option value="LVA">Latvia</option>
													<option value="LBN">Lebanon</option>
													<option value="LSO">Lesotho</option>
													<option value="LBR">Liberia</option>
													<option value="LBY">Libya</option>
													<option value="LIE">Liechtenstein</option>
													<option value="LTU">Lithuania</option>
													<option value="LUX">Luxembourg</option>
													<option value="MDG">Madagascar</option>
													<option value="MWI">Malawi</option>
													<option value="MYS">Malaysia</option>
													<option value="MDV">Maldives</option>
													<option value="MLI">Mali</option>
													<option value="MLT">Malta</option>
													<option value="MHL">Marshall Islands</option>
													<option value="MRT">Mauritania</option>
													<option value="MUS">Mauritius</option>
													<option value="MEX">Mexico</option>
													<option value="FSM">Micronesia</option>
													<option value="MDA">Moldova</option>
													<option value="MCO">Monaco</option>
													<option value="MNG">Mongolia</option>
													<option value="MNE">Montenegro</option>
													<option value="MAR">Morocco</option>
													<option value="MOZ">Mozambique</option>
													<option value="MMR">Myanmar</option>
													<option value="NAM">Namibia</option>
													<option value="NRU">Nauru</option>
													<option value="NPL">Nepal</option>
													<option value="NLD">Netherlands</option>
													<option value="NZL">New Zealand</option>
													<option value="NIC">Nicaragua</option>
													<option value="NER">Niger</option>
													<option value="NGA">Nigeria</option>
													<option value="PRK">North Korea</option>
													<option value="MKD">North Macedonia</option>
													<option value="NOR">Norway</option>
													<option value="OMN">Oman</option>
													<option value="PAK">Pakistan</option>
													<option value="PLW">Palau</option>
													<option value="PSE">Palestine State</option>
													<option value="PAN">Panama</option>
													<option value="PNG">Papua New Guinea</option>
													<option value="PRY">Paraguay</option>
													<option value="PER">Peru</option>
													<option value="PHL">Philippines</option>
													<option value="POL">Poland</option>
													<option value="PRT">Portugal</option>
													<option value="QAT">Qatar</option>
													<option value="ROU">Romania</option>
													<option value="RUS">Russia</option>
													<option value="RWA">Rwanda</option>
													<option value="KNA">Saint Kitts and Nevis</option>
													<option value="LCA">Saint Lucia</option>
													<option value="VCT">Saint Vincent and the Grenadines</option>
													<option value="WSM">Samoa</option>
													<option value="SMR">San Marino</option>
													<option value="STP">Sao Tome and Principe</option>
													<option value="SAU">Saudi Arabia</option>
													<option value="SEN">Senegal</option>
													<option value="SRB">Serbia</option>
													<option value="SYC">Seychelles</option>
													<option value="SLE">Sierra Leone</option>
													<option value="SGP">Singapore</option>
													<option value="SVK">Slovakia</option>
													<option value="SVN">Slovenia</option>
													<option value="SLB">Solomon Islands</option>
													<option value="SOM">Somalia</option>
													<option value="ZAF">South Africa</option>
													<option value="KOR">South Korea</option>
													<option value="SSD">South Sudan</option>
													<option value="ESP">Spain</option>
													<option value="LKA">Sri Lanka</option>
													<option value="SDN">Sudan</option>
													<option value="SUR">Suriname</option>
													<option value="SWE">Sweden</option>
													<option value="CHE">Switzerland</option>
													<option value="SYR">Syria</option>
													<option value="TJK">Tajikistan</option>
													<option value="TZA">Tanzania</option>
													<option value="THA">Thailand</option>
													<option value="TLS">Timor-Leste</option>
													<option value="TGO">Togo</option>
													<option value="TON">Tonga</option>
													<option value="TTO">Trinidad and Tobago</option>
													<option value="TUN">Tunisia</option>
													<option value="TUR">Turkey</option>
													<option value="TKM">Turkmenistan</option>
													<option value="TUV">Tuvalu</option>
													<option value="UGA">Uganda</option>
													<option value="UKR">Ukraine</option>
													<option value="ARE">United Arab Emirates</option>
													<option value="GBR">United Kingdom</option>
													<option value="USA">United States</option>
													<option value="URY">Uruguay</option>
													<option value="UZB">Uzbekistan</option>
													<option value="VUT">Vanuatu</option>
													<option value="VAT">Vatican City</option>
													<option value="VEN">Venezuela</option>
													<option value="VNM">Vietnam</option>
													<option value="YEM">Yemen</option>
													<option value="ZMB">Zambia</option>
													<option value="ZWE">Zimbabwe</option>
												</select>
												<span class="fa-light fa-chevron-down"></span>
											</div>
										</div>
									</div>
								</div>

								<div class="mb-4 border-b border-dark dark:border-light">
									<h3 class="mb-3 text-lg font-semibold">Caller ID</h3>
								</div>
								<div class="mb-2 flex w-full flex-row flex-wrap md:mb-5">
									<div class="w-full px-2 md:w-1/2">
										<div class="w-full">
											<p
												v-if="editSim?.account?.cliPolicy === 'OVERRIDE_FORCED'"
												class="mb-2 text-xs text-red-500"
											>
												Outbound Caller ID is currently overridden by the account settings which
												will take priority over any settings here.
											</p>
											<div class="formGroup">
												<label class="textGrey"
													>Outbound Caller ID (Optional - defaults to MSISDN)</label
												>
												<input
													v-model="editSim.cliOverride"
													type="text"
													class="form-control"
													placeholder="Enter caller ID"
												/>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="mb-4 border-b border-dark dark:border-light">
								<h3 class="mb-3 text-lg font-semibold">Additional Information</h3>
							</div>
							<div class="mb-4 flex w-full flex-wrap">
								<div class="w-full px-2">
									<div class="formGroup">
										<label class="textGrey">Description</label>
										<textarea
											v-model="editSim.description"
											class="form-control"
											rows="3"
											placeholder="Enter description..."
										></textarea>
									</div>
								</div>
							</div>
							<div class="margin-b20 flex px-2">
								<div class="col-md-12">
									<ul class="stepBtns">
										<li>
											<button
												:disabled="saving || editSim.id ? !hasSubscriberChanges : !isValid"
												class="jmiBtn btnLg green"
												@click="save()"
											>
												{{ saving ? 'Activating...' : editSim.id ? 'Save' : 'Activate' }}
											</button>
										</li>
										<li>
											<button class="jmiBtn btnLg red" @click="routeTo('/mobilesims')">
												Close
											</button>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<QRCodeModal v-if="showQRModal" :sim-id="selectedSimId" @close="closeQRCode()" />
	</div>
</template>

<script>
import mobilesimsApi from '../scripts/mobilesims/mobilesims.api.js'
import { router } from '../router/index.js'
import accountsApi from '@/scripts/accounts/accounts.api'
import {
	Dialog,
	DialogTrigger,
	DialogHeader,
	DialogTitle,
	DialogDescription,
	DialogContent
} from '@/components/ui/dialog'

export default {
	components: {
		Dialog,
		DialogTrigger,
		DialogHeader,
		DialogTitle,
		DialogDescription,
		DialogContent
	},
	inject: ['user', 'userRoles', 'tenants'],
	data() {
		return {
			editSim: {
				id: null,
				iccid: '',
				type: null,
				cliOverride: '',
				services: [],
				subscriber: {
					title: null,
					first_name: '',
					last_name: '',
					email: '',
					company: '',
					dob: '',
					address: '',
					postcode: '',
					city: '',
					country: ''
				},
				tenant: null,
				account: null,
				product: null
			},
			loading: false,
			saving: false,
			products: [],
			accounts: [],
			originalSubscriberInfo: null,
			showQRModal: false,
			selectedSimId: null
		}
	},

	computed: {
		tenantAccounts() {
			return this.accounts
				.filter((a) => a.tenant.id === this.editSim.tenant.id)
				.sort((a, b) => a.name.localeCompare(b.name))
		},
		tenantProducts() {
			return this.products.filter((p) => p.tenant.id === this.editSim.tenant.id)
		},
		isValid() {
			if (!this.editSim.type) return false
			// ICCID validation: 19-21 digits starting with 89
			if (this.editSim.type === 'psim' && !/^89\d{17,19}$/.test(this.editSim.iccid)) return false
			if (!this.editSim.subscriber.email) return false
			if (!this.editSim.subscriber.first_name) return false
			if (!this.editSim.subscriber.last_name) return false
			if (!this.editSim.tenant.id) return false
			if (!this.editSim.account.id) return false
			if (!this.editSim.product) return false
			return true
		},
		hasSubscriberChanges() {
			if (!this.originalSubscriberInfo) return false

			const subscriberFields = [
				'title',
				'first_name',
				'last_name',
				'company',
				'dob',
				'email',
				'address',
				'postcode',
				'city',
				'country'
			]

			return subscriberFields.some((field) => this.editSim[field] !== this.originalSubscriberInfo[field])
		},
		isTerminated() {
			return this.editSim.details?.status === 'Terminated'
		},
		isPending() {
			return this.editSim.details?.status?.toLowerCase().includes('pending')
		}
	},

	async created() {
		try {
			accountsApi
				.getAll({ limit: 2500 })
				.then((result) => {
					this.accounts = result.data.results
				})
				.catch(console.error)

			if (this.$route.params.id !== 'new') {
				const result = await mobilesimsApi.getById(this.$route.params.id)
				this.editSim = result.data
				if (this.editSim.subscriber)
					this.originalSubscriberInfo = JSON.parse(JSON.stringify(this.editSim.subscriber))
				else {
					this.editSim.subscriber = {}
					this.originalSubscriberInfo = null

					this.$swal({
						title: 'Error loading Mobile SIM',
						icon: 'error',
						confirmButtonText: 'Confirm',
						text: 'An error occurred loading SIM details, you will now be taken back to the SIM list. If the issue persists, please raise a support ticket.'
					}).then(() => {
						router.push('/mobilesims')
					})
				}
			} else if (this.tenants?.length === 1) {
				this.editSim.tenant = this.tenants[0]
			}
			this.loading = false
		} catch (e) {
			this.$swal({
				title: 'Error loading Mobile SIM',
				icon: 'error',
				confirmButtonText: 'Confirm',
				text: 'Unknown error occurred, please try again. If the issue persists, please raise a support ticket.'
			}).then(() => {
				router.push('/mobilesims')
			})
			console.error(e)
		}
		mobilesimsApi
			.getProducts()
			.then((result) => {
				this.products = result.data.results
			})
			.catch(console.error)
	},

	methods: {
		routeTo(routeName) {
			router.push(routeName)
		},
		save() {
			this.saving = true
			if (!this.editSim.id) {
				mobilesimsApi.create(this.editSim).then(this.onSave).catch(this.onError)
			} else {
				mobilesimsApi.update(this.editSim).then(this.onSave).catch(this.onError)
			}
		},
		tenantChanged() {
			this.editSim.product = null
			this.editSim.account = null
		},
		closeQRCode() {
			this.showQRModal = false

			if (!this.editSim.id) this.routeTo('/mobilesims')
		},
		onError(error) {
			this.saving = false
			console.error(error)
			this.$swal({
				title: 'Error Occurred',
				icon: 'error',
				confirmButtonText: 'Try Again',
				text: 'Unknown error occurred, please check the data and try again or contact support.'
			})
		},
		onSave(result) {
			this.saving = false
			if (result.success === false) {
				if (result.error === 'Duplicate entry') {
					this.$swal({
						title: 'Duplicate Number',
						icon: 'error',
						confirmButtonText: 'Try Again',
						text: 'This number is already in use. Please choose another.'
					})
				} else {
					this.$swal({
						title: 'Error Occurred',
						icon: 'error',
						confirmButtonText: 'Try Again',
						text: 'Unknown error occurred, please try again or contact support.'
					})
				}
			} else {
				if (!this.editSim.id && result.identifiers[0].id && this.editSim.type === 'esim') {
					this.selectedSimId = result.identifiers[0].id
					this.showQRModal = true
				} else {
					this.routeTo('/mobilesims')
				}
			}
		},
		showQRCode() {
			this.selectedSimId = this.editSim.id
			this.showQRModal = true
		},
		handleSuspend() {
			this.$swal({
				title: 'Suspend SIM',
				text: 'Are you sure you want to suspend this SIM?',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonText: 'Yes, suspend it',
				cancelButtonText: 'Cancel'
			}).then((result) => {
				if (result.isConfirmed) {
					mobilesimsApi
						.suspend(this.editSim.id)
						.then((response) => {
							if (response.status === 'success') {
								mobilesimsApi.getById(this.editSim.id).then((result) => {
									this.editSim = result.data
								})
								this.$swal({
									title: 'Success',
									text: 'SIM has been suspended',
									icon: 'success'
								})
							} else {
								this.$swal({
									title: 'Error',
									text: response.error || 'Failed to suspend SIM',
									icon: 'error'
								})
							}
						})
						.catch((error) => {
							console.error('Error suspending SIM:', error)
							this.$swal({
								title: 'Error',
								text: 'Failed to suspend SIM',
								icon: 'error'
							})
						})
				}
			})
		},

		handleReactivate() {
			this.$swal({
				title: 'Reactivate SIM',
				text: 'Are you sure you want to reactivate this SIM?',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonText: 'Yes, reactivate it',
				cancelButtonText: 'Cancel'
			}).then((result) => {
				if (result.isConfirmed) {
					mobilesimsApi
						.reactivate(this.editSim.id)
						.then((response) => {
							if (response.status === 'success') {
								mobilesimsApi.getById(this.editSim.id).then((result) => {
									this.editSim = result.data
								})
								this.$swal({
									title: 'Success',
									text: 'SIM has been reactivated',
									icon: 'success'
								})
							} else {
								this.$swal({
									title: 'Error',
									text: response.error || 'Failed to reactivate SIM',
									icon: 'error'
								})
							}
						})
						.catch((error) => {
							console.error('Error reactivating SIM:', error)
							this.$swal({
								title: 'Error',
								text: 'Failed to reactivate SIM',
								icon: 'error'
							})
						})
				}
			})
		},

		handleTerminate() {
			this.$swal({
				title: 'Terminate SIM',
				text: 'Are you sure you want to terminate this SIM? This action cannot be undone.',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonText: 'Yes, terminate it',
				cancelButtonText: 'Cancel'
			}).then((result) => {
				if (result.isConfirmed) {
					mobilesimsApi
						.terminate(this.editSim.id)
						.then((response) => {
							if (response.status === 'success') {
								mobilesimsApi.getById(this.editSim.id).then((result) => {
									this.editSim = result.data
								})
								this.$swal({
									title: 'Success',
									text: 'SIM has been terminated',
									icon: 'success'
								})
							} else {
								this.$swal({
									title: 'Error',
									text: response.error || 'Failed to terminate SIM',
									icon: 'error'
								})
							}
						})
						.catch((error) => {
							console.error('Error terminating SIM:', error)
							this.$swal({
								title: 'Error',
								text: 'Failed to terminate SIM',
								icon: 'error'
							})
						})
				}
			})
		},

		handleSync() {
			this.$swal({
				title: 'Sync SIM',
				text: 'Are you sure you want to sync this SIM?',
				icon: 'question',
				showCancelButton: true,
				confirmButtonText: 'Yes, sync it',
				cancelButtonText: 'Cancel'
			}).then((result) => {
				if (result.isConfirmed) {
					mobilesimsApi
						.sync(this.editSim.id)
						.then((response) => {
							if (response.success) {
								this.$swal({
									title: 'Success',
									text: 'SIM has been synced successfully',
									icon: 'success'
								})
							} else {
								this.$swal({
									title: 'Error',
									text: response.error || 'Failed to sync SIM',
									icon: 'error'
								})
							}
						})
						.catch((error) => {
							console.error('Error syncing SIM:', error)
							this.$swal({
								title: 'Error',
								text: 'Failed to sync SIM',
								icon: 'error'
							})
						})
				}
			})
		}
	}
}
</script>
